// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Paper = require("@mui/material/Paper").default;
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function MM_cmp_load_proof_to_editor(props) {
  var onCancel = props.onCancel;
  var onOk = props.onOk;
  var match = Local_storage_utils.useStateFromLocalStorageBool("load-proof-to-editor-adjustContext", true);
  var setAdjustContext = match[1];
  var adjustContext = match[0];
  var match$1 = Local_storage_utils.useStateFromLocalStorageBool("load-proof-to-editor-loadSteps", true);
  var setLoadSteps = match$1[1];
  var loadSteps = match$1[0];
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        children: Caml_option.some(null)
                      }, React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: adjustContext,
                                  onChange: Expln_React_common.evt2bool(function (b) {
                                        setAdjustContext(function (param) {
                                              return b;
                                            });
                                      })
                                }),
                            label: "Adjust the context"
                          }), React.createElement(FormControlLabel, {
                            control: React.createElement(Checkbox, {
                                  checked: loadSteps,
                                  onChange: Expln_React_common.evt2bool(function (b) {
                                        setLoadSteps(function (param) {
                                              return b;
                                            });
                                      })
                                }),
                            label: "Load intermediate steps"
                          }), React.createElement(Expln_React_Row.make, {
                            alignItems: "center",
                            children: Caml_option.some(null)
                          }, React.createElement(Button, {
                                onClick: (function (param) {
                                    onOk(adjustContext, loadSteps);
                                  }),
                                variant: "contained",
                                children: "Load"
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    onCancel();
                                  }),
                                children: "Cancel"
                              }))))
            });
}

var make = MM_cmp_load_proof_to_editor;

exports.make = make;
/* react Not a pure module */
